module.exports = __webpack_public_path__ + "static/media/asb_sur_typ_2.906635b0.png";